import { render, staticRenderFns } from "./sojishi.vue?vue&type=template&id=51490106&scoped=true&"
import script from "./sojishi.vue?vue&type=script&lang=js&"
export * from "./sojishi.vue?vue&type=script&lang=js&"
import style0 from "./sojishi.vue?vue&type=style&index=0&id=51490106&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51490106",
  null
  
)

export default component.exports